module.exports = __webpack_public_path__ + "images/instr-olivier.jpg";